import { Injectable } from '@angular/core';
import moment from 'moment-timezone';

/**
 * Horloge alignée sur le serveur.
 *
 * Les décisions horaires d'un LILATE (bouton « Rejoindre le test » et ouverture de la
 * salle 10 min avant le début, fermeture à la fin + 15 min) ne doivent pas dépendre
 * de l'horloge du poste : un ordinateur professionnel peut avoir une heure décalée
 * que le candidat ne peut pas régler (SUP-2371).
 *
 * `syncFromServerNow()` reçoit le champ `server_now` d'une réponse qui vient d'arriver
 * (fiche LILATE, liste « à venir », session d'examen) et mémorise l'écart avec
 * l'horloge locale, à la latence réseau près ; `now()` applique cet écart. Sans
 * synchronisation, l'écart vaut 0 : même comportement que `new Date()`.
 */
@Injectable({ providedIn: 'root' })
export class ServerClockService {

    private offsetMs = 0;

    /**
     * Mémorise l'écart entre l'heure du serveur et l'horloge locale.
     * À appeler à la réception d'une réponse fraîche (URL avec `salt`) : une réponse
     * mise en cache porterait une heure périmée. Une valeur absente ou illisible est
     * ignorée et l'écart précédent est conservé.
     */
    syncFromServerNow(serverNow: string | null | undefined, receivedAtMs: number = Date.now()): void {
        if (!serverNow) {
            return;
        }
        const serverNowMoment = moment(serverNow, moment.ISO_8601);
        if (!serverNowMoment.isValid()) {
            return;
        }
        this.offsetMs = serverNowMoment.valueOf() - receivedAtMs;
    }

    /** Heure du serveur estimée, en ms depuis l'epoch. */
    now(): number {
        return Date.now() + this.offsetMs;
    }

    nowDate(): Date {
        return new Date(this.now());
    }

    nowMoment(): moment.Moment {
        return moment(this.now());
    }
}
